import React, { Component } from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Loading from '../Loading'
import { menusArray, setCookie } from '../../constants';

class AuthenticatedUser extends Component {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.node,
    user: PropTypes.object,
    activeLink: PropTypes.string
  }

  static defaultProps = {
    location: {},
    children: null,
    user: {},
    activeLink: ''
  }

  static propTypes = {
    dispatch: PropTypes.func
  };
  static defaultProps = {
    dispatch: null
  }

  setNewCookie = (payload) => {
    const value = {
      email: payload.email,
      givenName: payload.firstname,
      imageUrl: payload.profilePicture,
    }
    setCookie('cdp-cookie', JSON.stringify(value), 7);
  }

  validUser = (user) => {
    const { activeLink } = this.props;
    const userRoles = (user?.UdrUsersPermissions || [])
      .map(p => p.UdrPermission?.role)
      .filter(Boolean);

    const hasAccess = (item) => {
      if (item.name === activeLink) {
        return true;
      }
      if (item.role && item.role.length) {
        return item.role.some(role => userRoles.includes(role));
      }
      if (item.subMenus && item.subMenus.length) {
        return item.subMenus.some(submenu => hasAccess(submenu));
      }
      return false;
    };

    return menusArray.some(menu => hasAccess(menu));
  }

  render() {
    const { children, location, user, isLoad } = this.props;
    if (isLoad) {
      return <Loading />;
    }
    if (user && user.id && this.validUser(user)) {
      this.setNewCookie(user);
      return children;
    } else {
      return <Redirect to={{
        pathname: '/',
        search: `redirectTo=${window.location.pathname}`,
        state: { from: location }
      }} />
    }
  }
}
export default connect(state => ({
  user: state.get('auth').get('user'),
  isLoad: state.get('auth').get('isLoad')
}))(AuthenticatedUser);
